import {
    Form,
    Outlet,
    useLoaderData,
    useNavigate,
    useRouteLoaderData,
    useSearchParams,
    useSubmit
} from "react-router-dom";
import {
    Modal,
    Container,
    Paper,
    Box,
    Button,
    FormControl,
    Grid,
    Stack,
    TextField,
    Typography,
    TableContainer,
    Table,
    TableRow,
    TableCell,
    TableHead,
    TableBody,
    Alert,
    IconButton,
    Tooltip,
    Chip,
    ImageList,
    ImageListItem,
    Divider,
    useMediaQuery,
    Card,
    CardContent
} from "@mui/material";
import {useMemo, useState} from "react";
import PlaceholderedImage from "../../../components/placeholderImage";
import ImageModal from "../../../components/imageModal";
import ImageModalSingle from "../../../components/imageModalSinglePhoto";
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import {addDays, addWeeks, differenceInDays, format, isBefore, isEqual, parse, parseISO, startOfWeek} from "date-fns";
import {uk} from 'date-fns/locale/uk';
import {DateRangePicker} from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {DialogPeople} from "../filter";
import DoneIcon from '@mui/icons-material/Done';
import {CloseOutlined} from "@mui/icons-material";
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import CheckIcon from '@mui/icons-material/Check';
import axios from "axios";
import React from 'react';
import {useRef, useEffect} from "react";
import {showSnackbar} from "../../../components/snackbarUtils";
import {Accordion, AccordionSummary, AccordionDetails} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";
import api from '../../../hooks/useApi';
import PageTitle from "../../../components/PageTitle";
import CloseIcon from "@mui/icons-material/Close";

export async function loader({request, params}) {
    const id = params.object_id || params.object_slug;
    const searchParam = (new URL(request.url)).searchParams.toString();
    const hotelObj = (await axios.get(`/api/booking_modules/use/obj_details/${id}/HotelObj/?${searchParam}`)).data;

    return {
        hotelObj, id
    };
}


export default function BookingObjectDetails() {
    const {hotelObj, id} = useLoaderData();
    const payload = 'parent=' + id;
    const {searchParams} = useRouteLoaderData('book_layout');
    const hotel = Array.isArray(hotelObj) ? hotelObj?.[0]?.hotel : hotelObj?.hotel;
    const hotelName = hotel?.name || hotelObj?.name;
    const [currentImageIndexHeader, setCurrentImageIndexHeader] = useState(null);
    const [currentImageIndexLittle, setCurrentImageIndexLittle] = useState(null);
    const [currentImageIndexAll, setCurrentImageIndexAll] = useState(null);
    const [imageSrc, setImageSrc] = useState(null);
    const [imageSrcSingle, setImageSrcSingle] = useState(null);
    const photoBlockRef = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        if (searchParams.booking_from?.[0] || searchParams.booking_to?.[0]) {

            const now = new Date();
            const bookingFromDate = parseISO(searchParams.booking_from?.[0]);
            const bookingToDate = parseISO(searchParams.booking_to?.[0]);
            bookingFromDate.setHours(0, 0, 0, 0);
            bookingToDate.setHours(0, 0, 0, 0);
            now.setHours(0, 0, 0, 0);

            if (isBefore(bookingFromDate, now) && !isEqual(bookingFromDate, now)) {
                showSnackbar("Помилка запиту: Дата бронювання у минулому!", "error", {
                    sx: {backgroundColor: "#ff0000", color: "white"},
                });
                navigate("/"); // Редирект на главную
            } else if (isBefore(bookingFromDate, now)) {
                showSnackbar("Помилка запиту: Дата бронювання у минулому!", "error", {
                    sx: {backgroundColor: "#ff0000", color: "white"},
                });
                navigate("/"); // Редирект на главную
            } else if (isBefore(bookingToDate, bookingFromDate)) {
                showSnackbar("Помилка запиту: Дата виїзду не може бути раніше дати заїзду!", "error", {
                    sx: {backgroundColor: "#ff0000", color: "white"},
                });
                navigate("/"); // Редирект на главную
            }
        }
    }, [searchParams.booking_from?.[0], searchParams.booking_to?.[0], navigate]);

    useEffect(() => {
        if (photoBlockRef.current) {
            photoBlockRef.current.scrollIntoView({behavior: "smooth", block: "start"});
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleNextImageAll = () => {
        setCurrentImageIndexAll((prevIndex) => {
            const nextIndex = prevIndex + 1 < hotel.hotel_image.length ? prevIndex + 1 : 0;
            return nextIndex;
        });
    };

    const handlePrevImageAll = () => {
        setCurrentImageIndexAll((prevIndex) => {
            const prevIndexNew = prevIndex - 1 >= 0 ? prevIndex - 1 : hotel.hotel_image.length - 1;
            return prevIndexNew;
        });
    };

    const handleNextImageLittle = () => {
        setCurrentImageIndexLittle((prevIndex) => {
            const nextIndex = prevIndex + 1 < hotel.hotel_image.length ? prevIndex + 1 : 0;
            return nextIndex;
        });
    };

    const handlePrevImageLittle = () => {
        setCurrentImageIndexLittle((prevIndex) => {
            const prevIndexNew = prevIndex - 1 >= 0 ? prevIndex - 1 : hotel.hotel_image.length - 1;
            return prevIndexNew;
        });
    };

    const handleNextImageHeader = () => {
        setCurrentImageIndexHeader((prevIndex) => {
            const nextIndex = prevIndex + 1 < hotel.hotel_image_for_booking_details.length ? prevIndex + 1 : 0;
            return nextIndex;
        });
    };

    const handlePrevImageHeader = () => {
        setCurrentImageIndexHeader((prevIndex) => {
            const prevIndexNew = prevIndex - 1 >= 0 ? prevIndex - 1 : hotel.hotel_image_for_booking_details.length - 1;
            return prevIndexNew;
        });
    };

    const conditions = hotel.accommodation_conditions ? hotel.accommodation_conditions : {};
    conditions.with_animals = hotel.with_animals_choices;
    const [selRooms, setSelRoom] = useState([]);
    const [showAllPhotos, setShowAllPhotos] = useState(false);
    const isMobile = useMediaQuery("(max-width:768px)");

    const displayedPhotos = showAllPhotos
        ? hotel.hotel_image
        : hotel.hotel_image.slice(0, 10);

    const displayedPhotosDescription = showAllPhotos
        ? hotel.image_descriptions_hotel_image
        : hotel.image_descriptions_hotel_image.slice(0, 10);

    const [isMapOpen, setIsMapOpen] = useState(false);

    const handleSelRooms = (obj, type) => {
        const currentObj = {
            id: obj.id,
            type,
            // сохраняем rate_id только если он пришёл (напр., из handleRatePick)
            rate_id: obj.rate_id ?? null,
        };

        setSelRoom((prev) => {
            const idx = prev.findIndex((item) => item.id === currentObj.id);
            if (idx >= 0) {
                // Номер уже выбран:
                // если прилетел новый rate_id — обновим, иначе считаем это "снять выбор"
                if (obj.rate_id != null) {
                    const copy = [...prev];
                    copy[idx] = {...copy[idx], rate_id: obj.rate_id};
                    return copy;
                }
                return prev.filter((item) => item.id !== currentObj.id);
            }
            // Номер ещё не выбран — добавим
            return [...prev, currentObj];
        });
    };


    const condition = (!hotelObj.MatchingChildren || hotelObj.MatchingChildren.length === 0) &&
        (!hotelObj.NonMatchingChildren || hotelObj.NonMatchingChildren.length === 0);

    const singleObj = condition ? [hotel] : false;

    return (
        <Box
            sx={{
                my: 8,
                "& > .MuiBox-root": {
                    my: 2,
                },
            }}
        >
            <PageTitle title={`Деталі об'єкта: ${hotelName || id}`}/>
            <Box>
                <Typography variant={isMobile ? "h6" : "h5"} sx={{fontWeight: "bold"}}>
                    {hotel.name}
                </Typography>
                <Box
                    sx={{
                        mt: 2,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 1,
                        justifyContent: isMobile ? "center" : "flex-start",
                    }}
                >
                    <PlaceOutlinedIcon sx={{color: "blue", fontSize: isMobile ? "1rem" : "1.5rem"}}/>

                    <Typography
                        variant="body2"
                        sx={{fontSize: isMobile ? "0.7rem" : "0.775rem", lineHeight: 1.3}}
                    >
                        {hotel.location.city.city}, {hotel.location.text_address}
                    </Typography>

                    {hotel?.location?.google_map && (
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => setIsMapOpen(true)}
                            sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                px: 1.2,
                                py: 0.2,
                                minHeight: "unset",
                                lineHeight: 1.2,
                                fontSize: isMobile ? "0.7rem" : "0.75rem",
                            }}
                        >
                            Подивитися на карті
                        </Button>
                    )}
                </Box>

            </Box>
            <Dialog
                open={isMapOpen}
                fullScreen={isMobile}
                onClose={(e, reason) => {
                    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
                    setIsMapOpen(false);
                }}
                sx={{
                    zIndex: 3000,
                    "& .MuiDialog-paper": {
                        m: 0,
                        width: "100%",
                        height: isMobile ? "100%" : "90vh",
                        maxWidth: "100%",
                        borderRadius: isMobile ? 0 : 2,
                        overflow: "hidden",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {backgroundColor: "transparent"},
                    },
                }}
            >
                <IconButton
                    onClick={() => setIsMapOpen(false)}
                    sx={{
                        position: "absolute",
                        right: 12,
                        top: isMobile ? 72 : 16,
                        zIndex: 10,
                        bgcolor: "background.paper",
                        boxShadow: 2,
                        "&:hover": {bgcolor: "background.paper"},
                    }}
                >
                    <CloseIcon/>
                </IconButton>

                <DialogContent sx={{p: 0, height: "100%"}}>
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            "& iframe": {
                                width: "100% !important",
                                height: "100% !important",
                                border: 0,
                                pointerEvents: "auto",
                            },
                        }}
                        dangerouslySetInnerHTML={{__html: hotel.location.google_map}}
                    />
                </DialogContent>
            </Dialog>


            <Box ref={photoBlockRef}>
                <Grid container spacing={1}>
                    {/* Большое главное фото */}
                    <Grid item xs={12} md={8}>
                        <Box
                            // Box                            sx={{
                            //                                 height: "100%",
                            //                                 maxHeight: "390px",
                            //                                 width: "100%",
                            //                                 maxWidth: "100%",
                            //                                 cursor: "pointer",
                            //                                 justifyContent: "center",
                            //                                 display: "flex",
                            //                                 overflow: "hidden",
                            //                                 borderRadius: "15px",
                            //                             }}
                        >
                            {hotel.hotel_image_for_booking_details.map((photo, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        height: "100%",       // Або конкретна висота, наприклад, "400px"
                                        maxHeight: "390px",   // Обмеження висоти
                                        width: "100%",        // Ширина контейнера
                                        maxWidth: "100%",     // Обмеження ширини
                                        cursor: "pointer",
                                        justifyContent: "center",
                                        display: "flex",
                                        overflow: "hidden",
                                        borderRadius: "15px",
                                    }}
                                    onClick={() => {
                                        setCurrentImageIndexHeader(index);
                                        setCurrentImageIndexLittle(null);
                                        setCurrentImageIndexAll(null)
                                    }} // Сохраняем индекс текущего фото
                                >
                                    {index === 0 && ( // Показываем изображение только для первого элемента
                                        <PlaceholderedImage
                                            src={photo} // Первое фото
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "cover",
                                                borderRadius: "15px",
                                            }}
                                            alt={`hotel-image-${index}`}
                                        />
                                    )}
                                </Box>
                            ))}
                            {/* Обработчик модального окна */}
                            {currentImageIndexHeader !== null && (
                                <ImageModal
                                    imageSrc={hotel.hotel_image_for_booking_details[currentImageIndexHeader]} // Текущее изображение
                                    setImageSrc={setImageSrc} // Закрытие модального окна
                                    handleNextImage={handleNextImageHeader} // Переход к следующему изображению
                                    handlePrevImage={handlePrevImageHeader} // Переход к предыдущему изображению
                                    resetCurrentImageIndex={() => setCurrentImageIndexHeader(null)}
                                    imageSingleDescriptions={hotel.hotel_image_descriptions_all[currentImageIndexHeader]}
                                />
                            )}
                        </Box>
                    </Grid>

                    {/* Маленькие фотографии */}
                    <Grid item xs={12} md={4}>
                        <Grid container spacing={1}>
                            {displayedPhotos.slice(1, 10).map((photo, index) => (
                                <Grid item xs={6} key={index}>
                                    <Box
                                        sx={{
                                            height: "70px",
                                            overflow: "hidden",
                                            borderRadius: "10px",
                                        }}
                                        onClick={() => {
                                            setCurrentImageIndexLittle(index);
                                            setCurrentImageIndexHeader(null);
                                            setCurrentImageIndexAll(null)
                                        }}
                                    >
                                        <img
                                            src={photo}
                                            alt={`Фото отеля ${index + 1}`}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                borderRadius: "10px",
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            ))}
                            {/* Рендер модального окна для выбранного изображения */}
                            {currentImageIndexLittle !== null && (
                                <ImageModal
                                    imageSrc={displayedPhotos[currentImageIndexLittle]} // Текущее изображение
                                    setImageSrc={setImageSrc}                      // Закрытие модального окна
                                    handleNextImage={handleNextImageLittle}              // Переход к следующему изображению
                                    handlePrevImage={handlePrevImageLittle}              // Переход к предыдущему изображению
                                    resetCurrentImageIndex={() => setCurrentImageIndexLittle(null)}
                                    imageSingleDescriptions={displayedPhotosDescription[currentImageIndexLittle]}
                                />
                            )}
                            {/* Кнопка "+N фотографий" */}
                            {!showAllPhotos && hotel.hotel_image.length > 6 && (
                                <Grid item xs={6}>
                                    <Box
                                        sx={{
                                            height: "70px",
                                            position: "relative",
                                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                                            color: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => setShowAllPhotos(true)}
                                    >
                                        <Typography variant="h6">
                                            +{hotel.hotel_image.length - 6} фотографій
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>

                {/* Полный просмотр фотографий */}
                {showAllPhotos && (
                    <Box sx={{mt: 2}}>
                        <Typography variant="h5" sx={{fontWeight: "bold", mt: 4, mb: 2}}>
                            Усі фотографії
                        </Typography>
                        <Grid container spacing={2}>
                            {hotel.hotel_image.map((photo, index) => (
                                <Grid item xs={6} sm={4} md={3} key={index}>
                                    <Box
                                        sx={{
                                            height: "150px",
                                            overflow: "hidden",
                                            borderRadius: "10px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        }}
                                        onClick={() => {
                                            setCurrentImageIndexAll(index); // Устанавливаем текущий индекс
                                            // setImageSrc(photo);          // Устанавливаем текущее изображение
                                            setCurrentImageIndexHeader(null);
                                            setCurrentImageIndexLittle(null)
                                        }}
                                    >
                                        <img
                                            src={photo}
                                            alt={`Фото отеля ${index + 1}`}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                borderRadius: "10px",
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>

                        {/* Рендер модального окна для выбранного изображения */}
                        {currentImageIndexAll !== null && (
                            <ImageModal
                                imageSrc={hotel.hotel_image[currentImageIndexAll]} // Текущее изображение
                                setImageSrc={setImageSrc}                      // Закрытие модального окна
                                handleNextImage={handleNextImageAll}              // Переход к следующему изображению
                                handlePrevImage={handlePrevImageAll}              // Переход к предыдущему изображению
                                resetCurrentImageIndex={() => setCurrentImageIndexAll(null)}
                                imageSingleDescriptions={hotel.image_descriptions_hotel_image[currentImageIndexAll]}
                            />
                        )}
                        <Box sx={{textAlign: "center", marginTop: "20px"}}>
                            <Button variant="contained" onClick={() => setShowAllPhotos(false)}>
                                Приховати фото
                            </Button>
                        </Box>
                    </Box>
                )}
            </Box>
            <Box>
                <div dangerouslySetInnerHTML={{__html: hotel.descriptions}}/>
            </Box>
            <Box>
                <Typography variant="h5" sx={{fontWeight: "bold"}}>
                    Наявність місць
                </Typography>
            </Box>
            <Box>
                <VerifySearchParams/>
            </Box>
            <Box>
                {(hotel.matching_children?.length > 0 || (singleObj && singleObj.length > 0)) && (
                    <>
                        {!isMobile && (
                            <Box>
                                <Alert severity="info" sx={{"& .MuiAlert-icon": {alignItems: "center"}}}>
                                    <Typography variant="h5" sx={{fontWeight: "bold"}}>
                                        Номера, що задовольняють умові фільтру
                                    </Typography>
                                </Alert>
                            </Box>
                        )}
                        <RoomsTable
                            data={hotel.matching_children}
                            selection={selRooms}
                            handler={handleSelRooms}
                            type={singleObj?.length > 0 ? "hotel" : "hotel_children"}
                            payload={payload}
                        />
                    </>
                )}
            </Box>
            {hotel.remaining_children?.length > 0 && (
                <>
                    {!isMobile && (
                        <Box>
                            <Alert severity="info" sx={{"& .MuiAlert-icon": {alignItems: "center"}}}>

                                <Typography variant="h5" sx={{fontWeight: "bold"}}>
                                    Схожі за запитом номера
                                </Typography>

                            </Alert>
                        </Box>
                    )}
                    <RoomsTable
                        data={hotel.remaining_children}
                        selection={selRooms}
                        handler={handleSelRooms}
                        type="hotel_children"
                        payload={payload}
                    />
                </>
            )}
            <Box>
                {imageSrcSingle &&
                    <ImageModalSingle imageSrcSingle={imageSrcSingle} setImageSrcSingle={setImageSrcSingle}
                                      imageSingleDescriptions={hotel.image_descriptions}/>}
            </Box>
            <Outlet/>
            {/*{*/}
            {/*    <Grid item xs={12} md={6}>*/}
            {/*        <Paper sx={{width: "250px", height: "200px", overflow: "hidden"}}>*/}
            {/*            {hotel && hotel.location?.google_map ? (*/}
            {/*                <div*/}
            {/*                    style={{width: "100%", height: "100%"}}*/}
            {/*                    dangerouslySetInnerHTML={{__html: hotel.location.google_map}}*/}
            {/*                />*/}
            {/*            ) : (*/}
            {/*                <Typography variant="body2" color="textSecondary">*/}
            {/*                    Данные недоступны*/}
            {/*                </Typography>*/}
            {/*            )}*/}
            {/*        </Paper>*/}
            {/*    </Grid>*/}
            {/*}*/}
        </Box>

    )
        ;
}

const VerifySearchParams = () => {
    const [urlSearchParams, setUrlSearchParams] = useSearchParams();   // 👈 добавили
    const {searchParams} = useRouteLoaderData('book_layout');

    /* keys of searchParams which should be avoided to place into hidden inputs to prevent duplications */
    const keysToExclude = ['booking_from', 'booking_to', 'adults', 'children', 'rooms', 'children_ages'];

    // собираем все пары key/value из URL за вычетом исключённых
    const filteredEntries = [];
    urlSearchParams.forEach((value, key) => {
        if (!keysToExclude.includes(key)) {
            filteredEntries.push([key, value]);
        }
    });
    const submit = useSubmit();

    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission

        const formData = new FormData(event.target);

        // Check if all children ages are set
        const numChildren = parseInt(formData.get('children') ?? 0, 10); // Ensure numChildren is properly retrieved
        const childrenAges = formData.getAll('children_ages');
        if (formData.get('city') === '') {
            alert('Будь ласка вкажіть місто.');
            return
        }
        if (childrenAges.length !== numChildren || childrenAges.some(age => age === "")) {
            alert('Будь ласка вкажіть вік всіх дітей.');
            return;
        }

        submit(formData, {
            method: 'get',
            action: ''
        })

    };
    const startDateIfNone = addDays(startOfWeek(new Date(), {weekStartsOn: 0}), 5);

    const bookingFromParam = urlSearchParams.get('booking_from');
    const bookingToParam = urlSearchParams.get('booking_to');

// 👉 начальные значения дат
    const initialStartDate = bookingFromParam
        ? parse(bookingFromParam, 'yyyy-MM-dd', new Date())
        : startDateIfNone;

    const initialEndDate = bookingToParam
        ? parse(bookingToParam, 'yyyy-MM-dd', new Date())
        : addWeeks(startDateIfNone, 2);

// 👉 локальный стейт диапазона для нижнего поля дат
    const [selectionRange, setSelectionRange] = useState({
        startDate: initialStartDate,
        endDate: initialEndDate,
        key: 'selection',
    });

// синхронизация, когда меняются booking_from / booking_to в URL
    useEffect(() => {
        if (!bookingFromParam || !bookingToParam) return;

        const from = parse(bookingFromParam, 'yyyy-MM-dd', new Date());
        const to = parse(bookingToParam, 'yyyy-MM-dd', new Date());

        setSelectionRange(prev => ({
            ...prev,
            startDate: from,
            endDate: to,
        }));
    }, [bookingFromParam, bookingToParam]);

    const handleSelectDateRange = (ranges) => {
        const {startDate, endDate} = ranges.selection;

        setSelectionRange(ranges.selection);               // локально обновили
        handleBottomDatesChange(startDate, endDate);       // 👈 и записали в URL
    };

    const [showRangeModal, setShowRangeModal] = useState(false);
    const handleModalRangePicker = () => {
        setShowRangeModal(prev => !prev);
    }

    const updateSearchParams = (params) => {
        const usp = new URLSearchParams(urlSearchParams);   // 👈 берем текущие search-параметры из хука

        Object.entries(params).forEach(([key, value]) => {
            if (value == null || value === '') {
                usp.delete(key);
            } else {
                usp.set(key, String(value));
            }
        });

        setUrlSearchParams(usp, {replace: true});         // 👈 уведомляем React Router
    };

    const handleBottomDatesChange = (from, to) => {
        updateSearchParams({
            booking_from: format(from, 'yyyy-MM-dd'),
            booking_to: format(to, 'yyyy-MM-dd'),
        });
    };

    const handleBottomGuestsChange = (adults, children) => {
        updateSearchParams({
            adults,
            children,
        });
    };

    const daysShort = {
        пон: 'пн',
        вів: 'вт',
        сер: 'ср',
        чтв: 'чт',
        птн: 'пт',
        суб: 'сб',
        нед: 'нд',
    };

    const isMobile = window.innerWidth <= 768; // Определение мобильного устройства

    const customLocale = {
        ...uk,
        localize: {
            ...uk.localize,
            day: (narrowDay, {width}) => {
                const daysShort = {
                    Mon: 'пн',
                    Tue: 'вт',
                    Wed: 'ср',
                    Thu: 'чт',
                    Fri: 'пт',
                    Sat: 'сб',
                    Sun: 'нд',
                };
                return width === 'abbreviated' ? daysShort[format(addDays(new Date(), narrowDay), 'eee')] : uk.localize.day(narrowDay, {width});
            },
        },
    };

    useEffect(() => {
        if (isMobile && showRangeModal && window.innerWidth < 375) {
            setTimeout(() => {
                const dateDisplayWrapper = document.querySelector('.rdrDateDisplayWrapper');
                if (dateDisplayWrapper) {
                    dateDisplayWrapper.style.width = '85%';
                }
                const rdrMonthAndYearWrapper = document.querySelector('.rdrMonthAndYearWrapper');
                if (rdrMonthAndYearWrapper) {
                    rdrMonthAndYearWrapper.style.width = '90%';
                }
                const rdrMonths = document.querySelectorAll('.rdrMonth'); // Находим все элементы
                rdrMonths.forEach((month) => {
                    month.style.width = '80%'; // Применяем стиль ко всем
                });
            }, 300); // Даем 300 мс на рендеринг
        } else if (isMobile && showRangeModal && window.innerWidth >= 375 && window.innerWidth < 425) {
            setTimeout(() => {
                const dateDisplayWrapper = document.querySelector('.rdrDateDisplayWrapper');
                if (dateDisplayWrapper) {
                    dateDisplayWrapper.style.width = '100%';
                }
                const rdrMonthAndYearWrapper = document.querySelector('.rdrMonthAndYearWrapper');
                if (rdrMonthAndYearWrapper) {
                    rdrMonthAndYearWrapper.style.width = '100%';
                }
                const rdrMonths = document.querySelectorAll('.rdrMonth'); // Находим все элементы
                rdrMonths.forEach((month) => {
                    month.style.width = '100%'; // Применяем стиль ко всем
                });
            }, 300); // Даем 300 мс на рендеринг
        }
    }, [isMobile, showRangeModal]); // Следим за `isMobile` и `showRangeModal`

    return (
        <>
            <Form
                method='get'
                onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <TextField
                                label='Період'
                                value={`${daysShort[format(selectionRange.startDate, 'eee', {locale: uk})]}, ${format(selectionRange.startDate, 'dd MMM', {locale: uk})} - ${daysShort[format(selectionRange.endDate, 'eee', {locale: uk})]}, ${format(selectionRange.endDate, 'dd MMM', {locale: uk})}`}
                                onClick={handleModalRangePicker}
                            />
                        </FormControl>
                        <Modal
                            open={showRangeModal}
                            className='flex abs-center'
                        >
                            <Container maxWidth='md' className='flex' sx={{height: 'fit-content'}}>
                                <Grid item container className='flex abs-center' component={Paper}
                                      sx={{p: '20px', height: '100%', overflowY: 'auto'}}>
                                    <div
                                        style={{
                                            maxWidth: '100%',
                                            overflowX: 'hidden',
                                            width: isMobile ? '100%' : 'fit-content', // Адаптация для мобильных устройств
                                            height: isMobile ? '100%' : 'auto'
                                        }}
                                    >
                                        <DateRangePicker
                                            ranges={[selectionRange]}
                                            onChange={handleSelectDateRange}
                                            locale={customLocale}
                                            showSelectionPreview={false}
                                            months={2}
                                            showDateDisplay={false}
                                            direction={isMobile ? 'vertical' : 'horizontal'} // Вертикально на мобильных
                                            minDate={new Date()} // Запрещаем выбор дат до текущей
                                        />
                                    </div>
                                    <Button fullWidth
                                            variant='contained'
                                            sx={{color: 'white'}}
                                            endIcon={<DoneIcon/>}
                                            color='buttonSuccess'
                                            onClick={handleModalRangePicker}>
                                        <Typography>Готово</Typography>
                                    </Button>
                                </Grid>
                            </Container>
                        </Modal>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <DialogPeople searchParams={searchParams}/>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button type='submit' variant='contained' fullWidth sx={{height: '100%'}}>Переглянути наявність
                            місць</Button>
                    </Grid>
                </Grid>
                {filteredEntries.map(([key, value], index) => (
                    <input
                        type="hidden"
                        key={`${key}-${index}`}
                        name={key}
                        value={value}
                    />
                ))}
                <input type='hidden' name='booking_from' value={format(selectionRange.startDate, 'yyyy-MM-dd')}/>
                <input type='hidden' name='booking_to' value={format(selectionRange.endDate, 'yyyy-MM-dd')}/>
            </Form>
        </>
    )
}

const RoomsTable = ({data, selection, handler, type, payload}) => {
    const [searchParams, setUrlSearchParams] = useSearchParams();
    const {stringifiedSearch} = useRouteLoaderData('book_layout')
    const isMobile = useMediaQuery("(max-width:768px)");
    const numNights = useMemo(() => {
        const start = parse(searchParams.get('booking_from'), 'yyyy-MM-dd', new Date())
        const end = parse(searchParams.get('booking_to'), 'yyyy-MM-dd', new Date())
        return (
            differenceInDays(end, start)
        )
    }, [searchParams])
    const [modalCfg, setModalCfg] = useState({
        open: false,
        data: {},
        mode: null
    });

    const [expanded, setExpanded] = useState(null);

    // локально храним выбранный тариф по roomId
    const [pickedRates, setPickedRates] = useState({});

    // useEffect(() => {
    //     const seed = {};
    //     (data || []).forEach((room) => {
    //         if (room?.rate_id) seed[room.id] = room.rate_id;
    //     });
    //     setPickedRates((prev) => ({...seed, ...prev}));
    // }, [data]);
    const [rateAvailability, setRateAvailability] = useState({}); // { [roomId]: { [rateId]: true/false } }

    const [extendConfirm, setExtendConfirm] = useState({
        open: false,
        from: null,
        to: null,
        nights: 0,
        room: null,
        rateId: null,
        rateObj: null
    });

    const closeExtendConfirm = () => setExtendConfirm((s) => ({...s, open: false}));

    const confirmExtendAndProceed = () => {
        // 1) обновляем URL-параметры через React Router
        const usp = new URLSearchParams(searchParams); // берём текущие из хука
        usp.set('booking_from', format(extendConfirm.from, 'yyyy-MM-dd'));
        usp.set('booking_to', format(extendConfirm.to, 'yyyy-MM-dd'));

        // это инициирует навигацию с новыми search-параметрами,
        // перезагрузит loader'ы и обновит searchParams/numNights
        setUrlSearchParams(usp, {replace: true});

        // 2) выбираем тариф как обычно
        const room = extendConfirm.room;
        const rateId = extendConfirm.rateId;

        setPickedRates((prev) => ({...prev, [room.id]: rateId}));

        // если номер ещё не выбран — выбрать
        const isRoomSelected = selection.some((i) => i.id === room.id);
        if (!isRoomSelected) {
            // ВАЖНО: прокинуть rate_id, как в обычном кейсе
            handler({...room, rate_id: rateId}, type);
        }

        closeExtendConfirm();
        showSnackbar('Період оновлено під мінімальну тривалість і тариф застосовано.', 'success');
    };


    // синхронизация из props.selection если там вдруг есть rate_id (на случай предзаполнения)
    useEffect(() => {
        const next = {};
        selection.forEach((it) => {
            if (it && it.id != null && it.rate_id != null) next[it.id] = it.rate_id;
        });
        setPickedRates((prev) => ({...prev, ...next}));
    }, [selection]);

    // Предпроверка на рендере: скрываем тарифы, если рекомендованные даты заняты
    useEffect(() => {
        const fromStr = searchParams.get('booking_from');
        if (!fromStr) return;
        const fromDate = parse(fromStr, 'yyyy-MM-dd', new Date());

        const requests = [];
        const nextMap = {};

        data.forEach((room) => {
            if (!Array.isArray(room.rates)) return;
            room.rates.forEach((rate) => {
                const minOn = Boolean(rate?.min_leave);
                const minN = Number(rate?.min_leave_night || 0);
                const needExtend = minOn && minN > numNights;
                if (!needExtend) return;
                const newTo = addDays(fromDate, minN);
                const newToStr = format(newTo, 'yyyy-MM-dd');
                const fromStrLocal = format(fromDate, 'yyyy-MM-dd');
                requests.push(
                    axios.get(`/api/booking_modules/use/check_availability`, {
                        params: {child_id: room.id, booking_from: fromStrLocal, booking_to: newToStr}
                    }).then(({data: av}) => {
                        if (!nextMap[room.id]) nextMap[room.id] = {};
                        nextMap[room.id][rate.id] = !!av?.available;
                    }).catch(() => {
                        if (!nextMap[room.id]) nextMap[room.id] = {};
                        nextMap[room.id][rate.id] = false; // при ошибке считаем недоступным
                    })
                );
            });
        });

        if (!requests.length) return;
        Promise.all(requests).then(() => setRateAvailability(nextMap));
    }, [data, numNights, searchParams]);

    // вернуть выбранный тариф для конкретного номера
    const getSelectedRateId = (roomId) => {
        if (pickedRates[roomId] != null) return pickedRates[roomId];
        const found = selection.find((i) => i.id === roomId);
        return found && found.rate_id != null ? found.rate_id : null;
    };

    // выбрать/переключить тариф (ровно один на номер)
    const handleRatePick = async (room, rateId, rateObj) => {
        const isRoomSelected = selection.some((i) => i.id === room.id);
        const currentRate = getSelectedRateId(room.id);

        // ➊ если кликаем по уже выбранному тарифу — просто снимаем выбор (без запросов и модалок)
        if (currentRate === rateId) {
            setPickedRates((prev) => {
                const {[room.id]: _, ...rest} = prev;
                return rest;
            });
            handler(room, type); // ✅ без rate_id → handleSelRooms удалит его из selRooms
            return;
        }
        const minOn = Boolean(rateObj?.min_leave);
        const minN = Number(rateObj?.min_leave_night || 0);
        const needExtend = minOn && minN > numNights;

        // если тариф требует больше ночей — предложим новые даты
        if (needExtend) {
            const fromStr = searchParams.get('booking_from');
            const fromDate = parse(fromStr, 'yyyy-MM-dd', new Date());
            const newTo = addDays(fromDate, minN);
            const newToStr = format(newTo, 'yyyy-MM-dd');

            // проверим занятость конкретного під-об’єкта на рекомендованные даты
            try {
                const {data: av} = await axios.get(`/api/booking_modules/use/check_availability`, {
                    params: {child_id: room.id, booking_from: fromStr, booking_to: newToStr}
                });
                if (!av?.available) {
                    showSnackbar('На рекомендовані дати номер зайнятий. Оберіть інший тариф або дати.', 'warning');
                    return;
                }
            } catch (e) {
                showSnackbar('Не вдалося перевірити наявність. Спробуйте пізніше.', 'error');
                return;
            }

            // дружелюбная модалка
            setExtendConfirm({
                open: true,
                from: fromDate,
                to: newTo,
                nights: minN,
                room,
                rateId,
                rateObj
            });
            return; // дальше продолжим после подтверждения в модалке
        }

        if (!isRoomSelected) {
            // ещё не выбран — выбрать номер и зафиксировать тариф
            setPickedRates((prev) => ({...prev, [room.id]: rateId}));
            handler({...room, rate_id: rateId}, type);
            return;
        }

        if (currentRate === rateId) {
            // повторный клик по тому же тарифу — снять выбор номера и тариф
            setPickedRates((prev) => {
                const {[room.id]: _, ...rest} = prev; // удалить ключ
                return rest;
            });
            handler(room, type); // родитель снимет выбор номера
            return;
        }

        // выбран другой тариф того же номера — просто заменяем локально (номер остаётся выбранным)
        setPickedRates((prev) => ({...prev, [room.id]: rateId}));
    };


    const handleRateTermsClick = async (event, el, rate, idx) => {
        event.stopPropagation();
        try {
            const res = await api.get(`/api/rule/child/${rate.rates_rules}/0/`);

            setModalCfg({
                open: true,
                data: {
                    ...el,
                    __rate: rate,
                    __rateIndex: idx,
                    __rules: res.data,
                },
                mode: 'term',
            });
        } catch (err) {
            console.error('Не вдалося завантажити умови тарифу', err);
        }
    };


    const handleExpand = (roomId) => {
        setExpanded((prev) => (prev === roomId ? null : roomId)); // Открытие/закрытие
    };

    // подписи цены/налога тарифа из полей rate.total_price / rate.total_tax
    const getRatePriceLabel = (rate) => {
        const price = Number(rate?.total_price || 0);
        if (!price) return '—';
        return `${formatNumber(price)} UAH`;
    };
    const getRateTaxLabel = (rate) => {
        const tax = Number(rate?.total_tax || 0);
        if (!tax) return null;
        return `податок ${formatNumber(tax)} UAH`;
    };

    // ===== Rate naming helpers =====
    const pluralNightsUa = (n) => {
        const i = Math.abs(Number(n)) % 100;
        const j = i % 10;
        if (i > 10 && i < 20) return 'ночей';
        if (j === 1) return 'ніч';
        if (j >= 2 && j <= 4) return 'ночі';
        return 'ночей';
    };

    const getMealsLabel = (rate) => {
        if (rate?.eats_all) return 'триразове харчування';
        const meals = [];
        if (rate?.eats_dinner) meals.push('сніданок');
        if (rate?.eats_supper) meals.push('обід');
        if (rate?.eats_brunch) meals.push('вечеря');
        if (!meals.length) return '';
        if (meals.length === 1) return `${meals[0]} включено`;
        // two or more
        return `${meals.slice(0, -1).join(' і ')} і ${meals.slice(-1)} включено`;
    };

    const getStayLabel = (rate) => {
        const minOn = Boolean(rate?.min_leave);
        const n = Number(rate?.min_leave_night || 0);
        if (minOn && n > 1) return `мін. ${n} ${pluralNightsUa(n)}`;
        if (!minOn || n <= 1) return 'Бронювання від 1 ночі';
        return '';
    };

    const getPrepayLabel = (rate) => {
        const units = rate?.another_amount_units;
        const amt = Number(rate?.another_amount_summ || 0);
        //if (units === 'percent' && amt > 0) return `передплата ${amt}%`;
        //if (units === 'money' && amt > 0) return `передплата ${formatNumber(amt)} UAH`;
        return '';
    };

    const getAdvanceBookingLabel = (rate) => {
        const mode = (rate?.booking_days || '').toString().toLowerCase();
        const amt = Number(rate?.booking_days_amount || 0);
        // якщо у полі не "no" і є кількість днів — показуємо вимогу попереднього бронювання
        if (mode !== 'no' && amt > 0) return `бронювання за ${amt} днів до приїзду`;
        return '';
    };

    const buildRateLabel = (rate, idx) => {
        const parts = [
            getMealsLabel(rate),
            getStayLabel(rate),
            getPrepayLabel(rate),
            getAdvanceBookingLabel(rate),
        ].filter(Boolean);
        const suffix = parts.length ? `${parts.join(' • ')}` : '';
        //const base = (rate?.name && String(rate.name).trim()) || `Тариф ${idx + 1}`;
        //return `${base}${suffix}`;
        return `${suffix}`;
    };
    // ===== End rate naming helpers =====

    const [imageSrc, setImageSrc] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(null);
    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) => {
            if (!modalCfg.data.hotel_image_for_booking_details) return 0; // Проверяем, есть ли изображения
            const nextIndex = prevIndex + 1 < modalCfg.data.hotel_image_for_booking_details.length ? prevIndex + 1 : 0;
            return nextIndex;
        });
    };

    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) => {
            if (!modalCfg.data.hotel_image_for_booking_details) return 0;
            const prevIndexNew = prevIndex - 1 >= 0 ? prevIndex - 1 : modalCfg.data.hotel_image_for_booking_details.length - 1;
            return prevIndexNew;
        });
    };

    const [rateWarnOpen, setRateWarnOpen] = useState(false);

    const canBook = useMemo(() => {
        if (selection.length < 1) return false;
        // Для каждого выбранного номера должен быть выбран тариф:
        return selection.every((item) => {
            const rid = getSelectedRateId(item.id); // уже есть в файле
            return rid != null && String(rid).length > 0;
        });
    }, [selection, pickedRates]); // pickedRates влияет через getSelectedRateId

    const checkoutUrl = useMemo(() => {
        const selectedIds = selection.map((item) => item.id).join(',');
        const selectedRates = selection
            .map((item) => `${(item.rate_id ?? pickedRates[item.id] ?? '')}`)
            .join(',');

        return `/book-checkout?${stringifiedSearch}&selected=${selectedIds}&selected_rates=${selectedRates}&${payload}&from=${window.location.pathname}${window.location.search}`;
    }, [selection, stringifiedSearch, payload, pickedRates]);

    const handleFloatingBookClick = () => {
        if (!canBook) {
            setRateWarnOpen(true);
            return;
        }
        window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
    };


    return (
        <>
            {isMobile ? (
                <Box sx={{pb: 12}}>
                    {data.map((el) => (
                        <Box key={el.id}>
                            <Paper
                                sx={{
                                    p: 2,
                                    mb: 2,
                                    borderRadius: '10px',
                                    boxShadow: 2,
                                    cursor: 'pointer',
                                    backgroundColor: selection.some((item) => item.id === el.id)
                                        ? 'lightblue'
                                        : 'white', // Выделяем выбранную карточку
                                }}
                            >
                                <Typography variant="h6" fontWeight="bold" sx={{mb: 1}}>
                                    {el.name}
                                </Typography>
                                <Typography variant="body1">
                                    {el.total_price ? (
                                        <span>{el.total_price} UAH</span>
                                    ) : (
                                        <Typography color="error">ой, ціна на обраний період
                                            відсутня {':('}</Typography>
                                    )}
                                </Typography>
                                {el.total_tax > 0 && (
                                    <Typography variant="body2" color="textSecondary">
                                        в т.ч. податки {el.total_tax} UAH
                                    </Typography>
                                )}

                                <Box sx={{mt: 1}}>
                                    <Typography variant="body2" fontWeight="bold">
                                        {el.guest_number_adults} дорослих
                                    </Typography>
                                    <Typography variant="body2" fontWeight="bold">
                                        {el.guest_number_children} дітей
                                    </Typography>
                                </Box>

                                <Box sx={{mt: 2, display: 'flex', flexDirection: 'column', gap: 1}}>
                                    <Accordion expanded={expanded === el.id} sx={{mt: 1}}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon
                                                sx={{color: "white"}}/>} // Делаем иконку белой
                                            onClick={() => handleExpand(el.id)}
                                            sx={{
                                                backgroundColor: "#1976D2", // Синий цвет (Material-UI primary)
                                                color: "white", // Белый текст
                                                "&:hover": {backgroundColor: "#1565C0"}, // Темнее при наведении
                                                borderRadius: "4px", // Скругляем края
                                            }}
                                        >
                                            <Typography>Фото номеру</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box sx={{
                                                display: "flex",
                                                overflowX: "auto",
                                                gap: 1,
                                                pb: 1, // Отступ снизу
                                                //"&::-webkit-scrollbar": {display: "none"} // Скрываем скроллбар
                                            }}>
                                                {el.hotel_image_for_booking_details.map((photo, index) => (
                                                    <Box key={index} sx={{
                                                        minWidth: "120px",
                                                        height: "100px",
                                                        cursor: "pointer"
                                                    }} onClick={() => {
                                                        setModalCfg({open: true, data: el, mode: 'photo'});
                                                        setCurrentImageIndex(index);
                                                    }}>
                                                        <img
                                                            src={photo}
                                                            alt={`Фото ${index + 1}`}
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                            }}
                                                        />
                                                    </Box>
                                                ))}
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>

                                    {/* 🎨 Модальное окно с галереей */}
                                    {modalCfg.open && modalCfg.mode === 'photo' && currentImageIndex !== null && (
                                        <ImageModal
                                            imageSrc={modalCfg.data.hotel_image_for_booking_details[currentImageIndex]}
                                            setImageSrc={setImageSrc}
                                            handleNextImage={handleNextImage}
                                            handlePrevImage={handlePrevImage}
                                            resetCurrentImageIndex={() => setCurrentImageIndex(null)}
                                            imageSingleDescriptions={modalCfg.data.hotel_image_descriptions_all[currentImageIndex]}
                                        />
                                    )}

                                    {/* Тарифи для номера */}
                                    <Box sx={{mt: 1}}>
                                        <Typography variant="subtitle2" sx={{mb: 0.5}}>Тарифи</Typography>
                                        {Array.isArray(el.rates) && el.rates.length > 0 ? (
                                            <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.5}}>
                                                {el.rates.map((rate, idx) => {
                                                    const selected = getSelectedRateId(el.id) === rate.id;
                                                    const priceLabel = getRatePriceLabel(rate);
                                                    const taxLabel = getRateTaxLabel(rate);
                                                    const minOn = Boolean(rate?.min_leave);
                                                    const minN = Number(rate?.min_leave_night || 0);
                                                    const needExtend = minOn && minN > numNights;
                                                    if (needExtend && rateAvailability[el.id] && rateAvailability[el.id][rate.id] === false) {
                                                        return null;
                                                    }
                                                    return (
                                                        <Box
                                                            key={rate.id}
                                                            sx={{
                                                                display: 'flex', alignItems: 'center', gap: 1, p: 1,
                                                                borderRadius: 1, border: '1px solid',
                                                                borderColor: selected ? 'primary.main' : 'divider',
                                                                bgcolor: selected ? 'action.selected' : 'transparent',
                                                                transition: 'all .15s ease',
                                                            }}
                                                            data-room-id={el.id}
                                                            data-rate-id={rate.id}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: 0.5,
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                {/* Верхній ряд: чекбокс + назва тарифу */}
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 1
                                                                }}>
                                                                    <Box
                                                                        sx={{
                                                                            flex: '0 0 32px',
                                                                            minWidth: 32,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                        }}
                                                                    >
                                                                        <RoomSelectCheckbox
                                                                            c={selected}
                                                                            o={() => handleRatePick(el, rate.id, rate)}
                                                                        />
                                                                    </Box>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            fontWeight: 500,
                                                                            mr: 1,
                                                                            '&:hover': {
                                                                                textDecoration: 'underline',
                                                                                cursor: 'pointer',
                                                                            },
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setModalCfg({
                                                                                open: true,
                                                                                data: {
                                                                                    ...el,
                                                                                    __rate: rate,
                                                                                    __rateIndex: idx
                                                                                },
                                                                                mode: 'rate',
                                                                            });
                                                                        }}
                                                                    >
                                                                        {buildRateLabel(rate, idx)}
                                                                    </Typography>
                                                                </Box>

                                                                {/* Нижній ряд: ціна, податки, обмеження, кнопка "Умови" */}
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                    }}
                                                                >
                                                                    <Chip size="small" variant="outlined"
                                                                          label={priceLabel}/>
                                                                    {taxLabel && <Chip size="small" label={taxLabel}/>}
                                                                    {Boolean(rate?.min_leave) && Number(rate?.min_leave_night) > 1 && (
                                                                        <Chip
                                                                            size="small"
                                                                            color="primary"
                                                                            variant="outlined"
                                                                            label={`тільки від ${rate.min_leave_night} ${pluralNightsUa(rate.min_leave_night)}`}
                                                                        />
                                                                    )}
                                                                    {Boolean(rate?.min_leave) && Number(rate?.min_leave_night) > numNights && (
                                                                        <Chip
                                                                            size="small"
                                                                            variant="outlined"
                                                                            label={`рекомендовані дати: ${format(
                                                                                parse(searchParams.get('booking_from'), 'yyyy-MM-dd', new Date()),
                                                                                'dd.MM'
                                                                            )}–${format(
                                                                                addDays(
                                                                                    parse(
                                                                                        searchParams.get('booking_from'),
                                                                                        'yyyy-MM-dd',
                                                                                        new Date()
                                                                                    ),
                                                                                    rate.min_leave_night
                                                                                ),
                                                                                'dd.MM'
                                                                            )}`}
                                                                        />
                                                                    )}

                                                                    <Box sx={{flexGrow: 1}}/>

                                                                    <Button
                                                                        size="small"
                                                                        variant="outlined"
                                                                        startIcon={<EventRepeatOutlinedIcon/>}
                                                                        onClick={(e) => handleRateTermsClick(e, el, rate, idx)}
                                                                    >
                                                                        Умови
                                                                    </Button>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    );
                                                })}
                                            </Box>
                                        ) : (
                                            <Typography variant="body2" color="textSecondary">Тарифи
                                                відсутні</Typography>
                                        )}
                                    </Box>

                                    <Button
                                        className="no-select"
                                        variant="contained"
                                        color="primary"
                                        startIcon={<InfoOutlinedIcon/>}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setModalCfg({open: true, data: el, mode: 'detail'});
                                        }}
                                    >
                                        Деталі
                                    </Button>
                                </Box>
                            </Paper>

                            {/* КНОПКА "ЗАБРОНЮВАТИ" ПОД ВЫБРАННОЙ КАРТОЧКОЙ */}
                            {/*{selection.some((item) => item.id === el.id) && (*/}
                            {/*    <Box sx={{*/}
                            {/*        mt: 1,*/}
                            {/*        mb: 2,*/}
                            {/*        display: 'flex',*/}
                            {/*        justifyContent: 'center',*/}
                            {/*        position: 'sticky',*/}
                            {/*        bottom: 10,*/}
                            {/*        zIndex: 1000*/}
                            {/*    }}>*/}
                            {/*        <Button*/}
                            {/*            variant="contained"*/}
                            {/*            color="success"*/}
                            {/*            disabled={selection.length < 1}*/}
                            {/*            component="a"*/}
                            {/*            target="_blank"*/}
                            {/*            href={`/book-checkout?${stringifiedSearch}&selected=${selection.map((item) => item.id).join(',')}&selected_rates=${*/}
                            {/*                selection.map((item) =>*/}
                            {/*                    `${(item.rate_id ?? pickedRates[item.id] ?? '')}`*/}
                            {/*                ).join(',')*/}
                            {/*            }&${payload}&from=${window.location.pathname}${window.location.search}`}*/}
                            {/*        >*/}
                            {/*            Забронювати обране*/}
                            {/*        </Button>*/}
                            {/*    </Box>*/}
                            {/*)}*/}
                        </Box>
                    ))}
                    {/* ✅ ПЛАВАЮЧА КНОПКА ЗАВЖДИ ВНИЗУ */}
                    <Box
                        sx={{
                            position: 'fixed',
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 2000,
                            p: 2,
                            bgcolor: 'background.paper',
                            borderTop: '1px solid',
                            borderColor: 'divider',
                        }}
                    >
                        <Button
                            fullWidth
                            variant="contained"
                            color="success"
                            onClick={handleFloatingBookClick}
                            aria-disabled={!canBook}
                            sx={{
                                opacity: canBook ? 1 : 0.6,
                            }}
                        >
                            Забронювати обране
                        </Button>
                    </Box>

                    {/* ✅ ПОПАП, ЯКЩО НЕ ОБРАНО ТАРИФ */}
                    <Dialog
                        open={rateWarnOpen}
                        onClose={() => setRateWarnOpen(false)}
                        maxWidth="xs"
                        fullWidth
                    >
                        <DialogTitle>Увага</DialogTitle>
                        <DialogContent dividers>
                            <Typography>
                                поставте галочку навпроти тарифу який вам підійшов
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setRateWarnOpen(false)} variant="contained" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            ) : (
                <TableContainer component={Paper} sx={{maxHeight: '90vh', overflow: 'auto'}}>
                    <Table stickyHeader sx={{
                        '& .MuiTableCell-head': {
                            padding: 1,
                            fontWeight: 'bold',
                            color: 'white',
                            backgroundColor: '#9A9FA4',
                        },
                        '& .MuiTableCell-body': {
                            verticalAlign: 'top',
                            p: 1,
                        },
                        '& .MuiTableCell-root:not(:last-child)': {
                            borderRight: '1px solid rgba(224, 224, 224, 1)',
                        },
                    }}>
                        <TableHead sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 10,               // выше всего, что внутри tbody
                            backgroundColor: '#9A9FA4',
                        }}>
                            <TableRow>
                                <TableCell>Тип номера</TableCell>
                                <TableCell>Ціна за {numNights} ночей</TableCell>
                                <TableCell align="center">Число гостей</TableCell>
                                <TableCell align="center">Действия</TableCell>
                                <TableCell align="center" sx={{width: 'fit-content'}}>
                                    Оберіть тариф
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((el) => (
                                <TableRow
                                    key={el.id}
                                    sx={{
                                        backgroundColor: selection.some((item) => item.id === el.id)
                                            ? 'lightblue'
                                            : 'white', // Цвет выбранной строки
                                        cursor: 'pointer',
                                    }}
                                >
                                    <TableCell>
                                        <Typography fontWeight="bold">{el.name}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        {el.total_price ? (
                                            <Typography>{el.total_price} UAH</Typography>
                                        ) : (
                                            <Typography>Можна переглянути наявні тарифи</Typography>
                                        )}
                                        {el.total_tax > 0 && (
                                            <Typography color="textSecondary">в т.ч.
                                                податки {el.total_tax} UAH</Typography>
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        <Typography>{el.guest_number_adults} дорослих</Typography>
                                        <Typography>{el.guest_number_children} дітей</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Stack direction="row" spacing={1}>
                                            {/* Кнопка с выпадающим списком */}
                                            <Accordion expanded={expanded === el.id} sx={{mt: 1, width: "100%"}}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon sx={{color: "white"}}/>}
                                                    onClick={() => handleExpand(el.id)}
                                                    sx={{
                                                        backgroundColor: "#1976D2",
                                                        color: "white",
                                                        "&:hover": {backgroundColor: "#1565C0"},
                                                        borderRadius: "4px",
                                                    }}
                                                >
                                                    <Typography>Фото номеру</Typography>
                                                </AccordionSummary>

                                                <AccordionDetails>
                                                    {/* Контейнер с фиксированной высотой и скроллом */}
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            overflowX: "auto",
                                                            gap: 2,
                                                            pb: 1,
                                                            width: "100%",      // На всю ширину
                                                            maxWidth: "360px",  // Фиксированная ширина под 3 фото
                                                            whiteSpace: "nowrap",
                                                            "&::-webkit-scrollbar": {height: "6px"},
                                                            "&::-webkit-scrollbar-thumb": {
                                                                backgroundColor: "#1976D2",
                                                                borderRadius: "3px",
                                                            },
                                                            "&::-webkit-scrollbar-track": {backgroundColor: "#E3F2FD"},
                                                        }}
                                                    >
                                                        {el.hotel_image_for_booking_details.map((photo, index) => (
                                                            <Box
                                                                key={photo}
                                                                sx={{
                                                                    flex: "0 0 auto",
                                                                    width: "120px", // Фиксированный размер миниатюры
                                                                    height: "90px",
                                                                    cursor: "pointer",
                                                                    borderRadius: "8px",
                                                                    overflow: "hidden",
                                                                    "&:hover": {opacity: 0.8},
                                                                }}
                                                                onClick={() => {
                                                                    setCurrentImageIndex(index);
                                                                    setModalCfg({open: true, data: el, mode: 'photo'});
                                                                }}
                                                            >
                                                                <img
                                                                    src={photo}
                                                                    alt={`Фото ${index + 1}`}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "cover"
                                                                    }}
                                                                />
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>

                                            {/* Модальное окно с изображением */}
                                            {modalCfg.open && modalCfg.mode === 'photo' && currentImageIndex !== null && (
                                                <ImageModal
                                                    imageSrc={modalCfg.data.hotel_image_for_booking_details[currentImageIndex]}
                                                    setImageSrc={setImageSrc}
                                                    handleNextImage={handleNextImage}
                                                    handlePrevImage={handlePrevImage}
                                                    resetCurrentImageIndex={() => setCurrentImageIndex(null)}
                                                    imageSingleDescriptions={modalCfg.data.hotel_image_descriptions_all[currentImageIndex]}
                                                />
                                            )}


                                            <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<InfoOutlinedIcon/>}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setModalCfg({
                                                        open: true,
                                                        data: el,
                                                        mode: 'detail',
                                                    });
                                                }}
                                            >
                                                Деталі
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                    <TableCell>
                                        {Array.isArray(el.rates) && el.rates.length > 0 ? (
                                            <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
                                                {el.rates.map((rate, idx) => {
                                                    const selected = getSelectedRateId(el.id) === rate.id;
                                                    const priceLabel = getRatePriceLabel(rate);
                                                    const taxLabel = getRateTaxLabel(rate);
                                                    const minOn = Boolean(rate?.min_leave);
                                                    const minN = Number(rate?.min_leave_night || 0);
                                                    const needExtend = minOn && minN > numNights;
                                                    if (needExtend && rateAvailability[el.id] && rateAvailability[el.id][rate.id] === false) {
                                                        return null;
                                                    }
                                                    return (
                                                        <Box
                                                            key={rate.id}
                                                            sx={{
                                                                display: 'flex', alignItems: 'center', gap: 1, p: 0.75,
                                                                borderRadius: 1, border: '1px solid',
                                                                borderColor: selected ? 'primary.main' : 'divider',
                                                                bgcolor: selected ? 'action.selected' : 'transparent',
                                                                transition: 'all .15s ease',
                                                            }}
                                                            data-room-id={el.id}
                                                            data-rate-id={rate.id}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: 0.5,
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 1
                                                                }}>
                                                                    <Box
                                                                        sx={{
                                                                            flex: '0 0 32px',
                                                                            minWidth: 32,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                        }}
                                                                    >
                                                                        <RoomSelectCheckbox
                                                                            c={selected}
                                                                            o={() => handleRatePick(el, rate.id, rate)}
                                                                        />
                                                                    </Box>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            fontWeight: 500,
                                                                            mr: 1,
                                                                            '&:hover': {
                                                                                textDecoration: 'underline',
                                                                                cursor: 'pointer',
                                                                            },
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setModalCfg({
                                                                                open: true,
                                                                                data: {
                                                                                    ...el,
                                                                                    __rate: rate,
                                                                                    __rateIndex: idx
                                                                                },
                                                                                mode: 'rate',
                                                                            });
                                                                        }}
                                                                    >
                                                                        {buildRateLabel(rate, idx)}
                                                                    </Typography>
                                                                </Box>

                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                    }}
                                                                >
                                                                    <Chip size="small" variant="outlined"
                                                                          label={priceLabel}/>
                                                                    {taxLabel && <Chip size="small" label={taxLabel}/>}
                                                                    {Boolean(rate?.min_leave) && Number(rate?.min_leave_night) > 1 && (
                                                                        <Chip
                                                                            size="small"
                                                                            color="primary"
                                                                            variant="outlined"
                                                                            label={`тільки від ${rate.min_leave_night} ${pluralNightsUa(rate.min_leave_night)}`}
                                                                        />
                                                                    )}
                                                                    {Boolean(rate?.min_leave) && Number(rate?.min_leave_night) > numNights && (
                                                                        <Chip
                                                                            size="small"
                                                                            variant="outlined"
                                                                            label={`рекомендовані дати: ${format(
                                                                                parse(searchParams.get('booking_from'), 'yyyy-MM-dd', new Date()),
                                                                                'dd.MM'
                                                                            )}–${format(
                                                                                addDays(
                                                                                    parse(
                                                                                        searchParams.get('booking_from'),
                                                                                        'yyyy-MM-dd',
                                                                                        new Date()
                                                                                    ),
                                                                                    rate.min_leave_night
                                                                                ),
                                                                                'dd.MM'
                                                                            )}`}
                                                                        />
                                                                    )}

                                                                    <Box sx={{flexGrow: 1}}/>

                                                                    <Button
                                                                        size="small"
                                                                        variant="outlined"
                                                                        startIcon={<EventRepeatOutlinedIcon/>}
                                                                        onClick={(e) => handleRateTermsClick(e, el, rate, idx)}
                                                                    >
                                                                        Умови
                                                                    </Button>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    );
                                                })}
                                            </Box>
                                        ) : (
                                            <Typography variant="body2" color="textSecondary">Тарифи
                                                відсутні</Typography>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Box sx={{mt: 3, display: 'flex', justifyContent: 'center'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={selection.length < 1}
                            component="a"
                            target="_blank"
                            href={`/book-checkout?${stringifiedSearch}&selected=${selection.map((item) => item.id).join(',')}&selected_rates=${
                                selection.map((item) =>
                                    `${(item.rate_id ?? pickedRates[item.id] ?? '')}`
                                ).join(',')
                            }&${payload}&from=${window.location.pathname}${window.location.search}`}
                        >
                            Забронювати обране
                        </Button>
                    </Box>
                </TableContainer>
            )}
            <RoomDetails modalCfg={modalCfg} setModalCfg={setModalCfg}/>
            <Dialog
                open={extendConfirm.open}
                onClose={closeExtendConfirm}
                maxWidth="xs"
                fullWidth
                aria-labelledby="extend-title"
            >
                <DialogTitle id="extend-title">
                    Підтвердити новий період?
                </DialogTitle>
                <DialogContent dividers>
                    <Stack spacing={1}>
                        <Typography variant="body2" color="text.secondary">
                            Обраний тариф діє <b>тільки від {extendConfirm.nights}</b> ночей.
                        </Typography>
                        <Divider/>
                        <Typography>
                            Пропонуємо змінити період на:
                        </Typography>
                        <Typography variant="h6">
                            {extendConfirm.from ? format(extendConfirm.from, 'dd.MM.yyyy') : '—'}
                            {' \u2192 '}
                            {extendConfirm.to ? format(extendConfirm.to, 'dd.MM.yyyy') : '—'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Це рівно {extendConfirm.nights} {pluralNightsUa(extendConfirm.nights)}.
                        </Typography>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeExtendConfirm} variant="outlined">
                        Скасувати
                    </Button>
                    <Button onClick={confirmExtendAndProceed} variant="contained" autoFocus>
                        Так, застосувати
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const RoomDetails = ({modalCfg, setModalCfg}) => {
    const data = modalCfg.data;
    const [currentImageIndex, setCurrentImageIndex] = useState(null);

    const RateContent = () => {
        const rate = data.__rate;
        if (!rate) return <Typography>Інформація про тариф відсутня</Typography>;

        return (
            <>
                <Typography variant="h6" sx={{mb: 2}}>
                    {typeof data.__rateIndex === 'number' ? `Тариф ${data.__rateIndex + 1}` : 'Тариф'}
                </Typography>

                {/* Харчування */}
                <Box sx={{mb: 2}}>
                    <Typography variant="subtitle2" sx={{mb: 1}}>Харчування</Typography>
                    {rate.eats_all ? (
                        <Chip label="Включено (все)"/>
                    ) : (
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            {/*<Chip variant={rate.eats ? 'filled' : 'outlined'}*/}
                            {/*      label={`Сніданок: ${rate.eats ? 'так' : 'ні'}`}/>*/}
                            <Chip variant={rate.eats_brunch ? 'filled' : 'outlined'}
                                  label={`Обід: ${rate.eats_brunch ? 'так' : 'ні'}`}/>
                            <Chip variant={rate.eats_supper ? 'filled' : 'outlined'}
                                  label={`Вечеря: ${rate.eats_supper ? 'так' : 'ні'}`}/>
                            <Chip variant={rate.eats_dinner ? 'filled' : 'outlined'}
                                  label={`Сніданок: ${rate.eats_dinner ? 'так' : 'ні'}`}/>
                        </Stack>
                    )}
                </Box>

                <Divider/>

                {/* Мінімальна тривалість проживання */}
                <Box sx={{mt: 2}}>
                    <Typography variant="subtitle2" sx={{mb: 1}}>Мінімальна тривалість</Typography>
                    {rate.min_leave ? (
                        <Chip variant="outlined" label={`Не менше ${rate.min_leave_night} ночі`}/>
                    ) : (
                        <Chip label="Без обмежень за тривалістю"/>
                    )}
                </Box>
            </>
        );
    };

    const DetailsContent = () => {
        return (<>
                {data.quadrature && (
                    <Typography>
                        Площа {data.quadrature} кв.м.
                    </Typography>
                )}
                {data.classification.name && (
                    <Typography>
                        Тип номера: {data.classification.name}
                    </Typography>
                )}
                <Divider/>
                <Box>

                    <Typography>Опис</Typography>
                    <Box dangerouslySetInnerHTML={{__html: data.descriptions}}/>
                </Box>

                {data.icons?.length > 0 && (
                    <>
                        <Divider/>
                        <Box>

                            <Typography sx={{mb: 1}}>
                                Зручності
                            </Typography>
                            <Grid container spacing={1}>
                                {data.icons.map((icon, index) => (
                                    <Grid item key={index}>
                                        <Chip
                                            sx={{backgroundColor: '#DCEDFF'}}
                                            avatar={<PlaceholderedImage
                                                src={icon.icon}
                                                title={icon.name}
                                                alt={icon.name}
                                                style={{
                                                    maxWidth: '40px',
                                                    maxHeight: '40px',
                                                    borderRadius: '15px'
                                                }}
                                            />}
                                            label={<Typography>{icon.name}</Typography>}
                                        />

                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </>
                )}
                {data.bedrooms?.length > 0 && (
                    <>
                        <Divider/>
                        <Box>
                            <Typography>Інформація про ліжка</Typography>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Тип</TableCell>
                                            <TableCell>Кількість спальних місць</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.bedrooms.map((bedroom, index) => (
                                            <React.Fragment key={index}>
                                                {bedroom.number_of_beds_type_single !== "0" && (
                                                    <TableRow>
                                                        <TableCell>Односпальне / ширина 80 -
                                                            130 см</TableCell>
                                                        <TableCell>{bedroom.number_of_beds_type_single}</TableCell>
                                                    </TableRow>
                                                )}
                                                {bedroom.number_of_beds_type_double !== "0" && (
                                                    <TableRow>
                                                        <TableCell>Двоспальне / ширина
                                                            131-150 см</TableCell>
                                                        <TableCell>{bedroom.number_of_beds_type_double}</TableCell>
                                                    </TableRow>
                                                )}
                                                {bedroom.number_of_beds_type_king !== "0" && (
                                                    <TableRow>
                                                        <TableCell>Широке двоспальне
                                                            (king-size) / ширина 151-180
                                                            см</TableCell>
                                                        <TableCell>{bedroom.number_of_beds_type_king}</TableCell>
                                                    </TableRow>
                                                )}
                                                {bedroom.number_of_beds_type_super_king !== "0" && (
                                                    <TableRow>
                                                        <TableCell>Особливо широке
                                                            двоспальне (king-size) / ширина
                                                            181-210
                                                            см</TableCell>
                                                        <TableCell>{bedroom.number_of_beds_type_super_king}</TableCell>
                                                    </TableRow>
                                                )}
                                                {bedroom.number_of_beds_type_bunk !== "0" && (
                                                    <TableRow>
                                                        <TableCell>Двоярусне ліжко /
                                                            змінного розміру</TableCell>
                                                        <TableCell>{bedroom.number_of_beds_type_bunk}</TableCell>
                                                    </TableRow>
                                                )}
                                                {bedroom.number_of_beds_type_sofa_bed !== "0" && (
                                                    <TableRow>
                                                        <TableCell>Диван ліжко / змінного
                                                            розміру</TableCell>
                                                        <TableCell>{bedroom.number_of_beds_type_sofa_bed}</TableCell>
                                                    </TableRow>
                                                )}
                                                {bedroom.number_of_beds_type_futon !== "0" && (
                                                    <TableRow>
                                                        <TableCell>Футон / Змінного
                                                            розміру</TableCell>
                                                        <TableCell>{bedroom.number_of_beds_type_futon}</TableCell>
                                                    </TableRow>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>

                    </>
                )}
            </>
        )
    }

    const TermsContent = () => {
        const rules = data.__rules;
        const form = rules?.form || null;
        const baseConditions = {...(data.accommodation_conditions || {})};

        const getChoiceLabel = (fieldName) => {
            if (!form || !form[fieldName]) return '';
            const field = form[fieldName];
            const value = field.initial;
            const choice = (field.choices || []).find(([val]) => val === value);
            return choice ? choice[1] : value;
        };

        // Заїзд / виїзд
        const arrival = form?.date_arrived?.initial ?? baseConditions.arrival;
        const departure = form?.date_arrived_out?.initial ?? baseConditions.departure;

        // Передплата (boolean)
        const prepayment = form?.prepayment?.initial ?? baseConditions.prepayment;

        // Сума скасування
        let cancellationAmount;
        if (form && form.cancellation_summ) {
            if (form.cancellation_summ.initial === 'custom') {
                const val = form.cancellation_summ_hidden?.initial;
                cancellationAmount = val ? `${val}` : '';
            } else {
                cancellationAmount = getChoiceLabel('cancellation_summ') || baseConditions.cancellation_summ;
            }
        } else {
            cancellationAmount = baseConditions.cancellation_summ;
        }

        // Сума скасування при незаїзді
        let cancellationNoShowAmount;
        if (form && form.cancellation_summ_no_arrived) {
            if (form.cancellation_summ_no_arrived.initial === 'custom') {
                const val = form.cancellation_summ_no_arrived_hidden?.initial;
                cancellationNoShowAmount = val ? `${val}` : '';
            } else {
                cancellationNoShowAmount = getChoiceLabel('cancellation_summ_no_arrived') || baseConditions.cancellation_summ_no_arrived;
            }
        } else {
            cancellationNoShowAmount = baseConditions.cancellation_summ_no_arrived;
        }

        // Політика скасування (читаем человекочитаемый label, если есть choices)
        const cancellationPolicy = form?.cancellation_policy
            ? getChoiceLabel('cancellation_policy') || baseConditions.cancellation_policy
            : baseConditions.cancellation_policy;

        // Ліжка для дітей
        const childBed = form?.child_bed?.initial ?? baseConditions.child_bed;

        // Варіант оплати
        const paymentOption = form?.payment_option_for_accommodation?.initial ?? baseConditions.payment_option;

        const conditions = {
            arrival,
            departure,
            cancellation_policy: cancellationPolicy,
            prepayment,
            cancellation_summ: cancellationAmount,
            cancellation_summ_no_arrived: cancellationNoShowAmount,
            child_bed: childBed,
            payment_option: paymentOption,
            with_animals: data.with_animals_choices,
        };

        return (
            <>
                <ConditionsTable conditions={conditions}/>
            </>
        );
    }

    const renderContent = () => {
        switch (modalCfg.mode) {
            case 'photo':
                let pol = 0;
                break
            case 'detail':
                return (<DetailsContent/>)
            case 'term':
                return (<TermsContent/>)
            case 'rate':
                return (<RateContent/>);
            default:
                <div>Інформація відсутня</div>
        }
    }
    const getLabel = () => {
        switch (modalCfg.mode) {
            case 'photo':
                let pol = 0;
                break
            case 'detail':
                return "Деталі номеру"
            case 'term':
                return "Передоплата та умови скасування номеру"
            case 'rate':
                return 'Деталі тарифу';
            default:
                <div>Невідомо.</div>
        }
    }
    if (!modalCfg.open || modalCfg.mode === 'photo') return null;

    return (
        <Modal open={modalCfg.open}>
            <Container maxWidth='md'
                       sx={{
                           height: '100%',
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'center'
                       }}>
                <Paper sx={{
                    padding: '20px',
                    maxHeight: '90vh',
                    minHeight: '50vh',
                    width: '100%',
                    overflow: 'auto'
                }}>
                    <Box className='flex stickSides' sx={{alignItems: 'center'}}>
                        <Typography>{getLabel()} {' '}
                            <Typography component='span' sx={{fontWeight: 'bold'}}>
                                {data.name}
                            </Typography>
                        </Typography>
                        <Tooltip arrow placement='top' title='Закрити'>
                            <IconButton onClick={() => {
                                setModalCfg({
                                    open: false,
                                    data: {},
                                    mode: null
                                })
                            }}>
                                <CloseOutlined/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Box className='modalContentBooking' sx={{
                        "& .MuiBox-root": {
                            my: 2
                        }
                    }}>
                        {isNonEmptyObject(data) ? (
                            <>
                                {renderContent()}
                            </>
                        ) : (
                            <>Нічого не знайдено!</>
                        )}
                    </Box>
                </Paper>
            </Container>
        </Modal>
    )
}

export function formatNumber(number) {
    const [integerPart, decimalPart] = Number(number).toFixed(2).split('.');

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return `${formattedInteger}.${decimalPart}`;
}

export function isNonEmptyObject(objectName) {
    return Object.keys(objectName).length > 0;
}

const RoomSelectCheckbox = ({c, o}) => {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof o === 'function') o(e);
    };
    return (
        <Box
            component="span"
            className="no-select"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 20,
                height: 20,
                border: '1px solid',
                borderColor: c ? 'primary.main' : 'text.secondary',
                borderRadius: '4px',
                backgroundColor: c ? 'primary.main' : 'transparent',
                cursor: 'pointer',
                transition: 'background-color 0.1s ease',
                userSelect: 'none',
            }}
            onClick={handleClick}
            role="checkbox"
            aria-checked={!!c}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') handleClick(e);
            }}
        >
            {c && (
                <CheckIcon
                    sx={{
                        fontSize: 16,
                        color: 'common.white',
                    }}
                />
            )}
        </Box>
    );
}

export const ConditionsTable = ({conditions}) => {
    const translatedAccommodations = {
        "arrival": "Заїзд",
        "departure": "Від'їзд",
        "cancellation_policy": "Політика скасування",
        "prepayment": "Передплата",
        "cancellation_summ": "Сума скасування",
        "cancellation_summ_no_arrived": "Сума скасування при незаїзді",
        "child_bed": "Дитячі ліжка",
        "payment_option": "Спосіб оплати",
        "with_animals": 'Можна з домашніми тваринами'
    };

    const isMobile = useMediaQuery("(max-width:768px)"); // Визначаємо мобільний пристрій

    return (
        <>
            {!isMobile ? (
                // Десктопна версія (таблиця)
                <TableContainer>
                    <Table>
                        <TableBody>
                            {Object.entries(conditions).map(([key, value]) => {
                                if (value != null)
                                    return (
                                        <TableRow key={key}>
                                            <TableCell sx={{whiteSpace: "nowrap", fontWeight: "bold"}}>
                                                {translatedAccommodations[key]}
                                            </TableCell>
                                            <TableCell>{typeof value === "boolean" ? (value ? "Так" : "Ні") : value}</TableCell>
                                        </TableRow>
                                    );
                                return null;
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                // Мобільна версія (список із картками)
                <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                    {Object.entries(conditions).map(([key, value]) => {
                        if (value != null)
                            return (
                                <Card key={key} sx={{p: 1}}>
                                    <CardContent>
                                        <Typography variant="subtitle2" sx={{fontWeight: "bold"}}>
                                            {translatedAccommodations[key]}
                                        </Typography>
                                        <Typography variant="body2">
                                            {typeof value === "boolean" ? (value ? "Так" : "Ні") : value}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            );
                        return null;
                    })}
                </Box>
            )}
        </>
    );
};
